const t=({maturity:t,countryName:o,countryRating:e,depositType:n})=>[n,t,o,`(${e})`].filter(Boolean).join(" ");export{t as getDetailInfo};
//# sourceMappingURL=getDetailInfo.js.map
